import { isEmpty } from 'lodash';
import { defaultNotificationTemplates, NotificationType } from './defaultValues';

export const isTrimedSettingNameValid = (string) => {
    if (!string) {
        return false;
    }
    return string.trim() !== '';
}

export const isErrorInNameProperty = (settingList, setting, action) => {
    const settingsList = action === 'Duplicate' ? settingList : settingList.filter(s => s.id !== setting.id);
    const isNameAlreadyTaken = settingsList.map(s => s.name).includes(setting.name);

    return isNameAlreadyTaken || !isTrimedSettingNameValid(setting.name);
}

export const isErrorInForm = (settingList, setting, action) => {
    const hasError = isErrorInNameProperty(settingList, setting, action)
        || !setting.createTemplatesHyperfind
        || !setting.manageShiftlinesHyperfind
        || !setting.manageAssignmentsHyperfind
        || setting.columnSet.dataview === ''
        || (!setting.workplanTemplateOptions.usePatternTemplate
            && !setting.workplanTemplateOptions.createPatternTemplate)
    return hasError
}

const getNotificationsValues = (settingSelected, notificationList) => {
    let notifications = { ...defaultNotificationTemplates }
    if (!isEmpty(settingSelected)) {
        const notifs = settingSelected.notifications;
        if (notifs && notifs.length) {
            const stopOwner = notifs.find(x => x.type === NotificationType.STOP_OWNER);
            if (stopOwner && stopOwner.templateId) {
                var notif = notificationList.find((x) => x.value === stopOwner.templateId);
                if (notif) {
                    notifications.stopOwner.templateId = notif.value;
                }
            }
        }
    }
    return notifications;
}

export const settingMapping = ({ settingSelected }, defaultValues, notificationList, action) => {

    const setttingNotifications = settingSelected.workflowNotifications || [];
    return ({
        breakRules: settingSelected.breakRules || [],
        columnSet: settingSelected.columnSet || defaultValues.columnSet,
        coverage: settingSelected.coverage || defaultValues.coverage,
        createTemplatesHyperfind: settingSelected.createTemplatesHyperfind,
        dataVisibility: settingSelected.dataVisibility || defaultValues.dataVisibility,
        description: settingSelected.description || '',
        employeeAssignement: settingSelected.employeeAssignement || defaultValues.employeeAssignement,
        importation: settingSelected.importation || defaultValues.importation,
        isUsedByWorkplan: settingSelected.isUsedByWorkplan,
        id: settingSelected.id,
        manageAssignmentsHyperfind: settingSelected.manageAssignmentsHyperfind,
        manageShiftlinesHyperfind: settingSelected.manageShiftlinesHyperfind,
        name: action === 'Duplicate' ? 'Copy of ' + settingSelected.name : settingSelected.name,
        notifications: getNotificationsValues(settingSelected, notificationList),
        schedulePeriod: settingSelected.schedulePeriod || defaultValues.schedulePeriod,
        shiftBiddingIntegration: settingSelected.shiftBiddingIntegration || defaultValues.shiftBiddingIntegration,
        shiftLineOptions: settingSelected.shiftLineOptions || defaultValues.shiftLineOptions,
        warning: settingSelected.warning || defaultValues.warning,
        workplanTemplateOptions: settingSelected.workplanTemplateOptions || defaultValues.workplanTemplateOptions,
        workflowNotifications: setttingNotifications.length ? settingSelected.workflowNotifications : defaultValues.workflowNotifications,
    });
}

export const stateMapping = (props, setting, initDualBox) => ({
    autoApproval: false,
    createTemplatesHyperfind: isEmpty(props.settingSelected) ? '' : props.settingSelected.createTemplatesHyperfind,
    dataviewColumns: props.dataviewColumns,
    dataviewDual: initDualBox(props.dataviewColumns, isEmpty(props.settingSelected) ? [] : props.settingSelected.columnSet.visibleColumns),
    description: isEmpty(props.settingSelected) ? '' : props.settingSelected.description,
    displayShiftHours: false,
    isModalOpen: false,
    manageAssignmentsHyperfind: isEmpty(props.settingSelected) ? '' : props.settingSelected.manageAssignmentsHyperfind,
    manageShiftlinesHyperfind: isEmpty(props.settingSelected) ? '' : props.settingSelected.manageShiftlinesHyperfind,
    name: isEmpty(props.settingSelected) ? '' : props.settingSelected.name,
    setting,
    showButtons: false,
    showErrorDialog: false,
    startDayWeek: '',

});

export const makeSubmitPayload = (state) => {
    let { setting, dataviewDual } = state;
    const {
        breakRules,
        columnSet,
        coverage,
        createTemplatesHyperfind,
        dataVisibility,
        description,
        importation,
        manageAssignmentsHyperfind,
        manageShiftlinesHyperfind,
        name,
        notifications,
        schedulePeriod,
        shiftBiddingIntegration,
        shiftLineOptions,
        standardShiftSet,
        warning,
        workflowNotifications,
        workplanTemplateOptions,
    } = setting;

    return ({
        breakRules,
        content: {
            columnSet: { ...columnSet, visibleColumns: dataviewDual.included.map(column => column.value) },
            schedulePeriod,
            standardShiftSet,
            workplanTemplateOptions,
            coverage,
            shiftLineOptions: shiftLineOptions,
            notifications: [shiftBiddingIntegration.enableShiftBiddingIntegration ? notifications.stopOwner : { ...defaultNotificationTemplates.stopOwner }],
            warning,
            importation,
            dataVisibility,
            shiftBiddingIntegration: {
                enableShiftBiddingIntegration: shiftBiddingIntegration.enableShiftBiddingIntegration,
                allowOwnerToBeAssignedToConcurentWorkplan: shiftBiddingIntegration.enableShiftBiddingIntegration && shiftBiddingIntegration.allowOwnerToBeAssignedToConcurentWorkplan,
            }
        },
        createTemplatesHyperfind,
        description,
        manageAssignmentsHyperfind,
        manageShiftlinesHyperfind,
        name,
        workflowNotifications,
    });
}